<template>
        <div class="product-video__wrapper">
            <div ref="AE_Video" class="product-video"></div>
        </div>
</template>
<script>
import { currency } from '@/lib'
import { mapGetters } from 'vuex'

export default {
    data(){
        return {
			AEBenefits: []
        }
    },
    mounted(){
				if(this.product[0]['AEECInitAccTreatUC.GMC'] && currency.format.number(this.product[0]['AEECInitAccTreatUC.GMC']) > 0) {
					this.AEBenefits.push(`${currency.format.USD(this.product[0]['AEECInitAccTreatUC.GMC'])} Urgent Care Visit`)
				}
				if(this.product[0]['AEECTeleMed.GMC'] && currency.format.number(this.product[0]['AEECTeleMed.GMC']) > 0) {
					this.AEBenefits.push(`${currency.format.USD(this.product[0]['AEECTeleMed.GMC'])} Telemedicine`)
				}
				if(this.product[0]['AESCPrescription.GMC'] && currency.format.number(this.product[0]['AESCPrescription.GMC']) > 0) {
					this.AEBenefits.push(`${currency.format.USD(this.product[0]['AESCPrescription.GMC'])} Prescription`)
				}
				if(this.product[0]['AEPreventiveCareBenefit.GMC'] && currency.format.number(this.product[0]['AEPreventiveCareBenefit.GMC']) > 0) {
					this.AEBenefits.push(`${currency.format.USD(this.product[0]['AEPreventiveCareBenefit.GMC'])} Preventive Care`)
				}
				if(this.product[0]['AESICDentalCrown.GMC'] && currency.format.number(this.product[0]['AESICDentalCrown.GMC']) > 0) {
					this.AEBenefits.push(`${currency.format.USD(this.product[0]['AESICDentalCrown.GMC'])} Dental Care`)
				}
				if(this.product[0]['AEHCHospAdmit.GMC'] && currency.format.number(this.product[0]['AEHCHospAdmit.GMC']) > 0) {
					this.AEBenefits.push(`${currency.format.USD(this.product[0]['AEHCHospAdmit.GMC'])} Hospital Admittance`)
				}
				const aeBenefits = {}
				this.AEBenefits.forEach((benefit, i) => Object.assign(aeBenefits, {['AEBenefit0' + (i + 1)]: benefit}))
        let blueRushVideoScript = document.createElement('script')
        blueRushVideoScript.setAttribute('src', 'https://d2ur3inljr7jwd.cloudfront.net/individeo/prod/edge/js/smartEmbed.js')
        blueRushVideoScript.setAttribute('data-iv-attachment-code', process.env.VUE_APP_BLUE_RUSH_ENV_AE)
        blueRushVideoScript.setAttribute('data-iv-lang', 'en-US')
        blueRushVideoScript.setAttribute('data-iv-use-branding', 'false')
        blueRushVideoScript.setAttribute('data-bp-enable-company-signature', 'false')
        blueRushVideoScript.setAttribute('data-bp-embed-smart-tracking', 'true')
        blueRushVideoScript.setAttribute('data-iv-individeo-data',  JSON.stringify({
            'Employer-Name': this.employer.Name,
            'AEECInitAccTreatER-GMC': currency.format.number(this.product[0]['AEECInitAccTreatER.GMC']),
            'AEECXray-GMC': currency.format.number(this.product[0]['AEECXray.GMC']),
            'AEECInitAccTreatmentDR-GMC': currency.format.number(this.product[0]['AEECInitAccTreatDR.GMC']),
            'AEECAmbulanceGR-GMC': currency.format.number(this.product[0]['AEECAmbulanceGR.GMC']),
            'Agent-Name': this.agent.Name,
            'Broker': this.agent.Name,
            'Employer': this.employer.Name,
            'CTA-Button': `${window.location.origin}/pdf/${this.$route.params.id}`,
            ...aeBenefits,
}))
        this.$refs.AE_Video.appendChild(blueRushVideoScript)
    },
    computed: {
        ...mapGetters({
            proposalId: 'getProposalId',
            product: 'getAccidentExpense',
            employer: 'getEmployer',
            agent: 'getAgent'
        })    
    },
    methods: {
    }
}
</script>
<style lang="scss" scoped>
.product-video__wrapper {
    position: relative;
    width: 100%;
		padding-bottom: calc(56.25% - 6px);
		border: 5px solid $gray;
		background: #ffffff;
}
.product-video {
    height: 0;
    width: 100%;

}
</style>
